import './i18n';
import 'inter-ui';
import App from './pages/App';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import Providers from './components/Providers/Providers';

import '@rainbow-me/rainbowkit/styles.css';

if ('ethereum' in window) {
  (window.ethereum as any).autoRefreshOnNetworkChange = false;
}

ReactDOM.render(
  <StrictMode>
    <Providers>
      <App />
    </Providers>
  </StrictMode>,
  document.getElementById('root'),
);
